export default "__VITE_ASSET__f9a5dd5a__"